<template>
    <Spinner v-if="isLoading" />
    <div class="removeplaceholder">        
        <Button v-if="!isMinisterstvo" :label="translated('removerefillpointbutton')" class="p-button-raised p-button-warning removeRefillPoint p-button-sm" icon="pi pi-trash" @click="removeRefillPointElement" />           			
        <Button v-if="!isMinisterstvo && RefillPoint.Fuel=='Electric'" :label="translated('refillpointpotrdilo')" class="p-button-raised p-button-info getRefillPointDoc p-button-sm" icon="pi pi-file-pdf" @click="getRefillPointStatement" />           			
    </div>
            
    <div class="field grid">
        <!-- <div class="col-6"> -->
        <div :class="RefillPoint.Fuel=='Electric' ? 'col-6' : 'col-12'">
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('fueltype') }}</label>
                <div class="col-12 md:col-8">
                    <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.Fuel" :options="FuelAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectfueltype')" />							
                </div>                        
            </div>	  

            <div class="field grid financiranje-group">
                <label class="col-12 md:col-4 mb-md-0 financiranje-label">{{ translated('financiranjerefillpointlabel') }}</label>
                <div class="col-12 md:col-8">
                    <MultiSelect :disabled="isMinisterstvo" v-model="RefillPoint.FinancedRecords" :options="FinancedAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('financiranjerefillpointlabelplace')" />	
                </div>                        
            </div>	

            <div v-if="RefillPoint.Fuel=='OrganicGas'">       
                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('organicgastype') }}</label>
                    <div class="col-12 md:col-8">		
                        <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.OrganicGasType" :options="OrganicGasTypeAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectorganicgast')" />												
                    </div>                        
                </div>     
            </div>  

            <div v-if="RefillPoint.Fuel=='Hydrogen'">
                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('hydrogentype') }}</label>
                    <div class="col-12 md:col-8">		
                        <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.HydrogenType" :options="HydrogenTypeAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectorganicgast')" />												
                    </div>                        
                </div>  

                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('refilsolution') }}</label>
                    <div class="col-12 md:col-8">		
                        <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.RefillSolution" :options="RefillSolutionAllOption" optionLabel="label" optionValue="value" :placeholder="translated('selectrefillsolution')" />												
                    </div>                        
                </div>

                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('processprotocol') }}</label>
                    <div class="col-12 md:col-8">
                        <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.ProcessProtocol" :options="ProcessProtocolAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectprocessprotocol')" />												
                    </div>                        
                </div>

                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('refuellingpressure') }}</label>
                    <div class="col-12 md:col-8">                    
                        <InputNumber :disabled="isMinisterstvo" v-model="RefillPoint.RefuellingPreassure" />			
                    </div>                        
                </div>	                
            </div>              


            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('pureenergy') }}</label>
                <div class="col-12 md:col-8">
                    <Checkbox :disabled="isMinisterstvo" v-model="RefillPoint.PureEnergy" :binary="true" />						
                </div>                        
            </div>	              

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0" :class="{'p-error': v$.RefillPoint.Name.$invalid && submitted}">{{ translated('companyname') }} *</label>
                <div class="col-12 md:col-8">
                    <InputText :disabled="isMinisterstvo" type="text" v-model="RefillPoint.Name" :class="{'p-invalid':v$.RefillPoint.Name.$invalid && submitted}" />							
                </div>                        
            </div>	  

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('externalsystemid') }}</label>
                <div class="col-12 md:col-8">
                    <InputText class="btneditenabledExternalId" type="text" v-model="RefillPoint.ExternalSystemId" :disabled="!editenabledExternalId || isMinisterstvo" />
                    <Button v-if="editenabledExternalId && !isMinisterstvo" icon="pi pi-lock-open" class="p-button-rounded p-button-warning editenabledExternalId" @click="editenabledExternalId=false" />
                    <Button v-if="!editenabledExternalId && !isMinisterstvo" icon="pi pi-lock" class="p-button-rounded p-button-warning editenabledExternalId" @click="editenabledExternalId=true" />

                </div>                        
            </div>	 

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('evseid') }}</label>
                <div class="col-12 md:col-8">
                    <InputText :disabled="isMinisterstvo" type="text" v-model="RefillPoint.EvseId" />							
                </div>                        
            </div>	 

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0" :class="{'p-error': v$.RefillPoint.RefillPointIndex.$invalid && submitted}">{{ translated('refillpointindex') }} *</label>
                <div class="col-12 md:col-8">
                    <InputNumber :disabled="isMinisterstvo" v-model="RefillPoint.RefillPointIndex" :class="{'p-invalid':v$.RefillPoint.RefillPointIndex.$invalid && submitted}" />							
                </div>                        
            </div>	 

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('isoperational') }}</label>
                <div class="col-12 md:col-8">
                    <Checkbox :disabled="isMinisterstvo" v-model="RefillPoint.IsOperational" :binary="true" />						
                </div>                        
            </div>	   

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('isused') }}</label>
                <div class="col-12 md:col-8">
                    <Checkbox v-model="RefillPoint.InUse" :binary="true" :disabled="true" />						
                </div>                        
            </div>	        
            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('parkingempty') }}</label>
                <div class="col-12 md:col-8">
                    <Checkbox v-model="RefillPoint.IsParkingEmpty" :binary="true" :disabled="true" />						
                </div>                        
            </div>	    

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('parkingprijaznoinvalidom') }}</label>
                <div class="col-12 md:col-8">
                    <Checkbox v-model="RefillPoint.AccessibleForPeopleWithDisabilities" :binary="true" />						
                </div>                        
            </div>	                          

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('servicetype') }}</label>
                <div class="col-12 md:col-8">
                    <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.ServiceType" :options="ServiceTypeAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectservicetype')" />							
                </div>                        
            </div>         

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('pricingpolicy') }}</label>
                <div class="col-12 md:col-8">
                    <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.PricingPolicy" :options="PricingPolicyAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectpricepolicy')" />							
                </div>                        
            </div>     

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('adhocpriceopt') }}</label>
                <div class="col-6 md:col-4">
                    <InputNumber :disabled="isMinisterstvo" v-model="RefillPoint.AdHocPricePerDeliveryUnit" mode="decimal" :minFractionDigits="2" locale="sl-SI" />
                </div>                   
                <div class="col-6 md:col-4">
                    <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.DeliveryUnit" :options="DeliveryUnitAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectdeliveryunit')" />
                </div>                        
            </div>             
            
            <!-- <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('deliveryunit') }}</label>
                <div class="col-12 md:col-8">
                    <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.DeliveryUnit" :options="DeliveryUnitAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectdeliveryunit')" />							
                </div>                        
            </div>    -->

            <div class="field grid">
                <label class="col-12 md:col-4 mb-md-0">{{ translated('reservability') }}</label>
                <div class="col-12 md:col-8">
                    <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.Reservability" :options="ReservabilityAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectreservabilitytype')" />							
                </div>                        
            </div>   
  

            <div v-if="RefillPoint.Fuel=='Electric'">
                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('extenderidentifier') }}</label>
                    <div class="col-12 md:col-8">
                        <InputText :disabled="isMinisterstvo" type="text" v-model="RefillPoint.ExtenderIdentifier" />							
                    </div>                        
                </div>

                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0" :class="{'p-error': v$.RefillPoint.ChargingPower.$invalid && submitted}">{{ translated('chargingpower') }} *</label>
                    <div class="col-12 md:col-8">
                        <InputNumber :disabled="isMinisterstvo" v-model="RefillPoint.ChargingPower" mode="decimal" :minFractionDigits="2" locale="sl-SI" :class="{'p-invalid':v$.RefillPoint.ChargingPower.$invalid && submitted}" />
                    </div>                        
                </div>    
                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0" :class="{'p-error': v$.RefillPoint.MaximumCurrent.$invalid && submitted}">{{ translated('maximumcurrent') }} *</label>
                    <div class="col-12 md:col-8">
                        <InputNumber :disabled="isMinisterstvo" v-model="RefillPoint.MaximumCurrent" :class="{'p-invalid':v$.RefillPoint.MaximumCurrent.$invalid && submitted}" />
                    </div>                        
                </div>
                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0" :class="{'p-error': v$.RefillPoint.Voltage.$invalid && submitted}">{{ translated('voltage') }} *</label>
                    <div class="col-12 md:col-8">
                        <InputNumber :disabled="isMinisterstvo" v-model="RefillPoint.Voltage" :class="{'p-invalid':v$.RefillPoint.Voltage.$invalid && submitted}" />							
                    </div>                        
                </div>  
                <!--  
                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">Green energy (%)</label>
                    <div class="col-12 md:col-8">
                        <InputText type="text" v-model="RefillPoint.GreenEnergyPercentyge" />							
                    </div>                        
                </div>   
                -->
                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('usagetype') }}</label>
                    <div class="col-12 md:col-8">
                        <MultiSelect :disabled="isMinisterstvo" v-model="RefillPoint.UsageTypes" :options="UsageTypesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectusagetypes')" />							
                    </div>                        
                </div>         

                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('chargingmode') }}</label>
                    <div class="col-12 md:col-8">
                        <Dropdown :disabled="isMinisterstvo" v-model="RefillPoint.ChargingSolutionMode" :options="ChargingSolutionModeAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectchargmode')" />							
                    </div>                        
                </div> 

                <div class="field grid">
                    <label class="col-12 md:col-4 mb-md-0">{{ translated('commtype') }}</label>
                    <div class="col-12 md:col-8">
                        <MultiSelect :disabled="isMinisterstvo" v-model="RefillPoint.VehicleToGridCommunicationTypes" :options="VehicleToGridCommunicationTypesAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectcommtype')" />					
                    </div>                        
                </div>         

            </div>        
                      

        </div>
        <div v-if="RefillPoint.Fuel=='Electric'" class="col-6 rightColData"> 
            <ConnectorsControl :Connectors="RefillPoint.Connectors" :submitted="submitted" @addNewConnector="addNewConnector" @removeConnector="removeConnector" />
        </div>
    </div>   


    <Dialog v-model:visible="displayDialogDocument" :style="{width: '30vw'}" :modal="true" :header="translated('RPStatementTitle')" class="globalDialog">
        <div class="card fluid">       
            <div class="field grid">
                <Checkbox class="col-1" v-model="optionFinance" :binary="true" /> 
                <label class="col-11">{{ translated('RPFinancne') }}</label>                                         
            </div>	
            <div class="field grid">
                <Checkbox class="col-1" v-model="optionLastna" :binary="true" /> 
                <label class="col-11">{{ translated('RPLastno') }}</label>                                         
            </div>	
            <div class="field grid">
                <Checkbox class="col-1" v-model="optionOstalo" :binary="true" /> 
                <label class="col-11">{{ translated('RPDrugo') }}</label>                                         
            </div>	
            <div class="field grid">
                <label class="col-1"></label>
                <div class="col-11">                    
                    <Textarea style="resize: none; overflow: auto;" :disabled="!optionOstalo" v-model="optionOstaloText" rows="3" /> 
                </div>                                                  
            </div>	
               												
        </div>
        <template #footer>
            <Button :label="translated('RPStatementClose')" icon="pi pi-times" @click="closeModal" class="p-button-text"/>
            <Button :label="translated('RPStatementGenerate')" icon="pi pi-check" @click="closeAddGenerate" autofocus />
        </template>
    </Dialog>


</template>

<script>
import { email, required, between, numeric, minLength, maxLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ConnectorsControl from '@/components/Connectors.vue';
import { computed } from "vue";
import store from "@/store";
import createHttp from "@/services/http";
import Spinner from "@/components/Spinner.vue"

export default {
    setup: () => ({ v$: useVuelidate() }),
    props: ['RefillPoint','submitted','FinancedAllOptions'],
    emits: ["removeRefillPoint"],
    components: { ConnectorsControl, Spinner },
    data() {
        return {
            isLoading: false,
            displayDialogDocument: false,
            optionFinance: false,
            optionLastna: false,
            optionOstalo: false,
            optionOstaloText: '',
            AccessibleForPeopleWithDisabilities: false,
            PureEnergy: false,
            editenabledExternalId: false,
            translated: computed(() => store.getters.getTranslate),
            Id: "",
            Fuel: "Electric",
            Name: "",
            EvseId: "",
            IsOperational: true,
            MaximumDeliveryAmount: 0,
            MinimumDeliveryAmount: 0,
            ModelType: "",
            Notes: "",
            RefillPointIndex: 0,
            PricingPolicy: "unknown",
            Reservability: "unknown",
            DeliveryUnit: "kWh",
            OrganicGasType: "all",
            RenewableSourceRatio: 0,
            ProcessProtocol: "unknown",
            RefillSolution: "unknown",
            UsageTypes: [],
            VehicleToGridCommunicationTypes: [],
            ChargingSolutionMode: "unknown",
            ExtenderIdentifier: "",
            GreenEnergyPercentage: 0,
            Voltage: 0,
            ChargingPower: 0,
            MaximumCurrent: 0,
            Connectors: [],
            FuelAllOptions: [
                {label: "Electric", value: "Electric"},
                {label: "Hydrogen", value: "Hydrogen"},
                {label: "Gas", value: "OrganicGas"}                
            ],
            UsageTypedAllOptions : [
                {label: "electricalDevices", value: "electricalDevices"},
                {label: "electricBikeOrMotorcycle", value: "electricBikeOrMotorcycle"},
                {label: "electricVehicle", value: "electricVehicle"},
                {label: "lorryPowerConsumption", value: "lorryPowerConsumption"},
                {label: "motorhomeOrCaravanSupply", value: "motorhomeOrCaravanSupply"},
                {label: "other", value: "other"}
            ],
            ServiceTypeAllOptions: [
                {label: "fullService", value: "fullService"},
                {label: "selfService", value: "selfService"},
                {label: "unattended", value: "unattended"}
            ],
            PricingPolicyAllOptions: [
                {label:"contract", value:"contract"},
                {label:"flatRate", value:"flatRate"},
                {label:"free", value:"free"},
                {label:"other", value:"other"},
                {label:"pricePerChargingTime", value:"pricePerChargingTime"},
                {label:"pricePerDeliveryUnit", value:"pricePerDeliveryUnit"},
                {label:"unknown", value:"unknown"}
            ],
            ReservabilityAllOptions: [
                {label:"mandatory", value:"mandatory"},
                {label:"notAvailable", value:"notAvailable"},
                {label:"partly", value:"partly"},
                {label:"unknown", value:"unknown"},
                {label:"unspecified", value:"unspecified"}
            ],
            DeliveryUnitAllOptions: [
                {label:"gasGallonEquivalent", value:"gasGallonEquivalent"},
                {label:"imperialGallon", value:"imperialGallon"},
                {label:"kg", value:"kg"},
                {label:"kWh", value:"kWh"},
                {label:"litre", value:"litre"},
                {label:"m3", value:"m3"},
                {label:"usGallon", value:"usGallon"}
            ],
            OrganicGasTypeAllOptions: [
                // {label:"all", value:"all"},
                // {label:"biogas", value:"biogas"},
                {label:"cng", value:"cng"},
                {label:"lng", value:"lng"},
                {label:"lpg", value:"lpg"},
                // {label:"other", value:"other"}
                // {label:"field", value:"field"}
            ],
            HydrogenTypeAllOptions: [
                {label:"gaseous", value:"gaseous"},
                {label:"liquified", value:"liquified"}
            ],
            ProcessProtocolAllOptions: [
                {label:"mcMethod", value:"mcMethod"},
                {label:"sae2601v2010", value:"sae2601v2010"},
                {label:"sae2601v2014", value:"sae2601v2014"},
                {label:"sae2601v2016", value:"sae2601v2016"},
                {label:"unknown", value:"unknown"}
            ],
            RefillSolutionAllOption: [
                {label:"liquidHydrogen", value:"liquidHydrogen"},    
                {label:"cryoCompressedHydrogren", value:"cryoCompressedHydrogren"},
                {label:"gaseousHydrogen350barCar", value:"gaseousHydrogen350barCar"},
                {label:"gaseousHydrogen350barTruck", value:"gaseousHydrogen350barTruck"},
                {label:"gaseousHydrogen700barCar", value:"gaseousHydrogen700barCar"},
                {label:"gaseousHydrogen700barTruck", value:"gaseousHydrogen700barTruck"},
                
                // {label:"unknown", value:"unknown"}
            ],
            UsageTypesAllOptions: [
                {label:"electricalDevices", value:"electricalDevices"},
                {label:"electricBikeOrMotorcycle", value:"electricBikeOrMotorcycle"},
                {label:"electricVehicle", value:"electricVehicle"},
                {label:"lorryPowerConsumption", value:"lorryPowerConsumption"},
                {label:"motorhomeOrCaravanSupply", value:"motorhomeOrCaravanSupply"},
                {label:"other", value:"other"}
            ],
            ChargingSolutionModeAllOptions: [
                {label:"ac", value:"ac"},
                {label:"dc", value:"dc"},
                {label:"ccs", value:"ccs"},
                {label:"wireless", value:"wireless"},
                {label:"other", value:"other"},
                {label:"unknown", value:"unknown"}
            ],
            VehicleToGridCommunicationTypesAllOptions: [
                {label:"iec619802", value:"iec619802"},
                {label:"iso15118", value:"iso15118"},
                {label:"none", value:"none"},
                {label:"other", value:"other"},
                {label:"unknown", value:"unknown"}                
            ]
        }
    },
    watch: {
        // I need to watch this.optionLastna and when its changed to true then i need to set optionFinance to false
        optionLastna(newValue, oldValue) {
            if(newValue) {
                this.optionFinance = false;
                this.optionOstalo = false;
                this.optionOstaloText = '';
            }
        },
        optionFinance(newValue, oldValue) {
            if(newValue) {
                this.optionLastna = false;
                this.optionOstalo = false;
                this.optionOstaloText = '';
            }
        },
        optionOstalo(newValue, oldValue) {
            if(newValue) {
                this.optionFinance = false;
                this.optionLastna = false;
            }
        }
        

    },
    validations() {
        let myvalidations = {
            RefillPoint: {
				Name: { required },
                RefillPointIndex: { required }
                // Voltage: { required },
                // ChargingPower: { required },
                // MaximumCurrent: { required }
			} 
        };

        if(this.isElectric) { 
            myvalidations.RefillPoint.Voltage = { required }; 
            myvalidations.RefillPoint.ChargingPower = { required }; 
            myvalidations.RefillPoint.MaximumCurrent = { required }; 
        }
        
       // console.log('validator:');
       // console.log(myvalidations);


        return myvalidations;
    },	    
    mounted() {
        // console.log('KLIČEM MOUNTED RefillPoint CONTROL !!!!')
        // console.log(this.FinancedAllOptions, this.RefillPoint);

        // I need to transform object RefillPoint.FinancedWith array of objects to an array of strings and i will take RefillPoint.FinancedWith.Id 
        // Add safety check before mapping
        this.RefillPoint.FinancedRecords = this.RefillPoint?.FinancedWith?.map(item => item.Id) || [];
    },
    computed: {
        isElectric() {
            // console.log('IsElectric:' + this.RefillPoint.Fuel=='Electric');
            return this.RefillPoint.Fuel=='Electric';
        },
		isMinisterstvo() {
            return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));            
			//return true;
        }
    },      
    methods: {
        setDates() {
            this.RefillPoint.CreatedDate = Date.now()
            this.RefillPoint.LastUpdated = Date.now() 
            //console.log(this.RefillPoint);
        },
        removeRefillPointElement() {
            //console.log('kličem remove refill point. Prožim event!!!');
            this.$emit('removeRefillPoint', {id: this.RefillPoint.Id, CreatedDate: this.RefillPoint.CreatedDate}) 
        },

        closeModal() {
            this.displayDialogDocument = false;
        },
        async closeAddGenerate() {

            if(this.optionOstalo && this.optionOstaloText.length < 5) {
                return;
            }

            this.displayDialogDocument = false;
            await this.getRefillPointStatementFromServer();
        },

        async getRefillPointStatement() {
            this.optionFinance = true;            
            this.displayDialogDocument = true;
        },
        async getRefillPointStatementFromServer() {
            this.isLoading = true;
            const http = createHttp(true); 
            const tmpId = this.RefillPoint.Id; // == '' ? '00000000-0000-0000-0000-000000000000' : this.Id;

            const optionOstaloTextEncoded = encodeURIComponent(this.optionOstaloText);

            const url = process.env.VUE_APP_API_FOLDER + `/GetRefillPointStatement?refillPointId=${tmpId}&pridobitevFS=${this.optionFinance}&lastnauporaba=${this.optionLastna}&drugo=${optionOstaloTextEncoded}`;
            try {
                console.log(url);
                // Fetch the PDF file as a blob
                const response = await http.get(url, { responseType: "blob" });
                console.log(response);
                const fileBlob = new Blob([response.data], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(fileBlob);
                
                // Open the blob URL in a new tab/window
                window.open(fileURL, "_blank");
            } catch (error) {
                console.error("Error opening PDF file:", error);
                // Optionally, display an error message to the user.
            }
            this.isLoading = false;
        },
        getClassByType() {
            return "col-6";
        },
        addNewConnector(newConn) {
            /*
            console.log('new connector');
            console.log(newConn);
            console.log(this.RefillPoint.Connectors);
            */
            if(!this.RefillPoint.Connectors){
                //console.log('kreiram nov arra');
                this.RefillPoint.Connectors = new Array();
                //console.log(this.RefillPoint.Connectors);
            }
                

            this.RefillPoint.Connectors.push(newConn);
        },
        removeConnector(conn) {
            
            //console.log('prisel v refill point v remove connector');
            //console.log(conn);

            const arr = this.RefillPoint.Connectors.filter(function(item) {
                if(conn.Id && conn.Id != '00000000-0000-0000-0000-000000000000') {
                   // console.log('imama id in ni prazen!');
                    return item.Id !== conn.Id
                }                
                else {
                    /*
                    console.log('nimam id, vzameme DateAdded');
                    console.log(item.DateAdded);
                    console.log(conn.DateAdded);
                    */
                    return item.DateAdded !== conn.DateAdded
                }
                    
            })

            this.RefillPoint.Connectors = arr  
        }
    }    

}
</script>

<style scoped>
button.removeRefillPoint, button.getRefillPointDoc {
    width: auto;
    margin: 5px;
}
.rightColData {
	border-left: 1px solid lightgrey;
}

.removeplaceholder button {
    position: relative;
    float: right;
    top: -13px;
    right: -13px;
}

.removeplaceholder {
    position: relative;
    width: 100%;
    float: left;
    height: 30px;
}

input.btneditenabledExternalId {
	width: calc( 100% - 50px );
}

button.editenabledExternalId {
	margin-left: 10px;
}

.field.grid.financiranje-group {
    background: #ffb352;
    font-weight: bold;
    padding: 5px;
}
</style>